var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "header full_layout",
          on: {
            mouseleave: function($event) {
              return _vm.hideMenu("userinfo")
            }
          }
        },
        [
          _c("div", { staticClass: "flex_display flex_one align_center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("ul", { staticClass: "headerMenu" }, [
              _c(
                "li",
                {
                  class: _vm.path[0] == "" || _vm.path[0] == "home" ? "on" : "",
                  on: {
                    mouseenter: function($event) {
                      return _vm.hideMenu("market")
                    }
                  }
                },
                [
                  _c("router-link", { attrs: { to: { path: "/" } } }, [
                    _vm._v(_vm._s(_vm.$t("Home")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("li", { class: _vm.path[0] == "market" ? "on" : "" }, [
                _c(
                  "span",
                  {
                    on: {
                      mouseenter: function($event) {
                        return _vm.showMenu("market")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("DakaMarket")))]
                )
              ]),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: _vm.path[0] == "point" ? "on" : "",
                  on: {
                    mouseenter: function($event) {
                      return _vm.hideMenu("market")
                    }
                  }
                },
                [
                  _c("router-link", { attrs: { to: { path: "/point" } } }, [
                    _vm._v(_vm._s(_vm.$t("PointsMall")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.path[0] == "cypher" ? "on" : "" },
                [
                  _vm.userInfo != null
                    ? _c(
                        "router-link",
                        { attrs: { to: { path: "/user/exchange" } } },
                        [_vm._v(_vm._s(_vm.$t("TradeCards")))]
                      )
                    : _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.goLogin("login")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("TradeCards")))]
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.path[0] == "information" ? "on" : "" },
                [
                  _c("router-link", { attrs: { to: { path: "/info" } } }, [
                    _vm._v(_vm._s(_vm.$t("DakaNews")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { class: _vm.path[0] == "about" ? "on" : "" },
                [
                  _c("router-link", { attrs: { to: { path: "/about" } } }, [
                    _vm._v(_vm._s(_vm.$t("AboutUs")))
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-input",
            {
              staticClass: "headerSearch",
              attrs: { placeholder: _vm.$t("Search") },
              model: {
                value: _vm.searchTxt,
                callback: function($$v) {
                  _vm.searchTxt = $$v
                },
                expression: "searchTxt"
              }
            },
            [
              _c("i", {
                staticClass: "searchIcon",
                attrs: { slot: "prefix" },
                slot: "prefix"
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lang" },
            [
              _vm.$i18n.locale === "en"
                ? [
                    _c("img", {
                      attrs: { src: "/static/images/lang-en.png" },
                      on: {
                        click: function($event) {
                          return _vm.setLanguage("zh")
                        }
                      }
                    })
                  ]
                : [
                    _c("img", {
                      attrs: { src: "/static/images/lang-zh.png" },
                      on: {
                        click: function($event) {
                          return _vm.setLanguage("en")
                        }
                      }
                    })
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cart",
              on: {
                mouseenter: function($event) {
                  return _vm.hideMenu("userinfo")
                }
              }
            },
            [
              _vm.userInfo == null
                ? _c("span", {
                    on: {
                      click: function($event) {
                        return _vm.goLogin("login")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userInfo != null && _vm.iscart
                ? _c(
                    "el-badge",
                    { staticClass: "item", attrs: { "is-dot": "" } },
                    [_c("router-link", { attrs: { to: { path: "/cart" } } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userInfo != null && !_vm.iscart
                ? _c("router-link", { attrs: { to: { path: "/cart" } } })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "topUser" }, [
            _vm.userInfo == null
              ? _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goLogin("login")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SignIn")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.userInfo != null
              ? _c("span", {
                  staticClass: "userOn",
                  class:
                    _vm.userInfo.Level > 1 ? "lv lv" + _vm.userInfo.Level : "",
                  on: {
                    mouseenter: function($event) {
                      return _vm.showMenu("userinfo")
                    }
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.dislogType.market && _vm.category != null
            ? _c(
                "div",
                {
                  staticClass: "getmarket",
                  on: {
                    mouseleave: function($event) {
                      return _vm.hideMenu("market")
                    }
                  }
                },
                [
                  _c(
                    "ul",
                    { staticClass: "marketfirst" },
                    _vm._l(_vm.category, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          class: _vm.categoryIndex == index ? "on" : "",
                          on: {
                            mouseenter: function($event) {
                              return _vm.setChildren(index)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$i18n.locale === "zh"
                                  ? item.label
                                  : item.EnName || item.label
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.category[_vm.categoryIndex].children.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "marketsecond" },
                        _vm._l(
                          _vm.category[_vm.categoryIndex].children,
                          function(it, i) {
                            return _c("li", { key: i }, [
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.MenuUserGo(
                                        "/market?f=" + it.Fid + "&s=" + it.id,
                                        "market"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$i18n.locale === "zh"
                                          ? it.label
                                          : it.EnName || it.label
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            ])
                          }
                        ),
                        0
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dislogType.userinfo
            ? _c(
                "div",
                {
                  staticClass: "getuserinfo",
                  on: {
                    mouseleave: function($event) {
                      return _vm.hideMenu("userinfo")
                    }
                  }
                },
                [
                  _c("ul", { staticClass: "getuserinfoUl" }, [
                    _c("li", [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.MenuUserGo("/user/info", "userinfo")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon_user" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("AccountInfo")) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.MenuUserGo("/user/order", "userinfo")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon_order" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("OrderHistory")) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.MenuUserGo("/user/address", "userinfo")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon_add" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("ShippingAddresses")) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.MenuUserGo("/cart", "userinfo")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon_cart" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("ShoppingCart")) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.MenuUserGo("/user/point", "userinfo")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon_point" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Points")) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.MenuUserGo(
                                "/user/exchange",
                                "userinfo"
                              )
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon_exchange" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("TradeCards")) +
                              "\n          "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.MenuUserGo("", "userinfo")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon_layout" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("SignOut")) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.dislogType.login
        ? _c("to-login", {
            attrs: {
              title: _vm.$t("SignIn"),
              domVisible: _vm.dislogType.login
            },
            on: { closeDialog: _vm.closeDialog, godialog: _vm.godialog }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dislogType.register
        ? _c("to-register", {
            attrs: {
              title: _vm.$t("SignUp"),
              domVisible: _vm.dislogType.register
            },
            on: { closeDialog: _vm.closeDialog, godialog: _vm.godialog }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dislogType.forgot
        ? _c("to-forgot", {
            attrs: {
              title: _vm.$t("ResetPassword"),
              domVisible: _vm.dislogType.forgot
            },
            on: { closeDialog: _vm.closeDialog, godialog: _vm.godialog }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo", attrs: { href: "/" } }, [
      _c("img", { attrs: { src: require("../../static/images/logo.svg") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29e8c3c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e8c3c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 